module.exports = __webpack_public_path__ + "static/media/master5.48861061.png";